import React from "react";
var __jsx = React.createElement;
// https://hitchhikers.yext.com/docs/pages/rich-text-markdown/
import { LexicalRichText } from '@yext/pages-components';
import styled from 'styled-components';
import styles from './YextRichText.style.js';
function YextRichText(_ref) {
  var serializedAST = _ref.serializedAST,
    className = _ref.className;
  return __jsx("div", {
    className: "nva-yrt ".concat(className)
  }, __jsx(LexicalRichText, {
    className: "nva-yrt",
    nodeClassNames: {
      blockCursor: 'nva-yrt__block-cursor',
      characterLimit: 'nva-yrt__character-limit',
      code: 'nva-yrt__code',
      codeHighlight: 'nva-yrt__code-highlight',
      embedBlock: 'nva-yrt__embed-block',
      hashtag: 'nva-yrt__hashtag',
      heading: 'nva-yrt__heading',
      image: 'nva-yrt__image',
      indent: 'nva-yrt__indent',
      link: 'nva-yrt__link',
      list: 'nva-yrt__list',
      ltr: 'nva-yrt__ltr',
      mark: 'nva-yrt__mark',
      markOverlap: 'nva-yrt__mark-overlap',
      paragraph: 'nva-yrt__paragraph u-body2',
      quote: 'nva-yrt__quote',
      root: 'nva-yrt__root',
      rtl: 'nva-yrt__rtl',
      table: 'nva-yrt__table',
      text: {
        base: 'nva-yrt__text u-body2',
        bold: 'nva-yrt__text--bold',
        code: 'nva-yrt__text--code',
        highlight: 'nva-yrt__text--highlight',
        italic: 'nva-yrt__text--italic',
        strikethrough: 'nva-yrt__text--strikethrough',
        subscript: 'nva-yrt__text--subscript',
        superscript: 'nva-yrt__text--superscript',
        underline: 'nva-yrt__text--underline',
        underlineStrikethrough: 'nva-yrt__text--underline-strikethrough'
      }
    },
    serializedAST: serializedAST
  }));
}
export default styled(YextRichText).withConfig({
  componentId: "sc-1xpceee-0"
})(["", ";"], styles);